import { useQuery } from '@tanstack/react-query';
import apiClient from '../libs/apiClient';
import { Forms } from '../types/forms';
import { ApiResponse } from '../types/response';

const useGetForm = (isEnabled: boolean) => {
  return useQuery({
    queryKey: ['forms'],
    queryFn: async () => {
      const { data: responseData } = await apiClient.get<ApiResponse<Forms>>('/forms');
      return responseData.data;
    },
    enabled: isEnabled,
    staleTime: Infinity,
  });
};

export default useGetForm;
